import { setupAmplitude } from '../analytics';
import useOnMountEffect from '../hooks/useOnMountEffect';
import useLoadTracking from './useLoadTracking';

const AmplitudeTracking = () => {
  const { load } = useLoadTracking();
  if (!load) {
    return null;
  }
  return <AmplitudeWrapper />;
};

const AmplitudeWrapper = () => {
  useOnMountEffect(() => {
    setupAmplitude();
  });
  return null;
};

export default AmplitudeTracking;
